import { useLocation, useParams } from "react-router-dom";
import { AppDispatch, RootState } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { fetchBuildings } from "../../../redux/slices/buildingsSlice";
import toast from "react-hot-toast";
import { getAdminData, getRemainingLinceces, toggleAdminStatus } from "../../../redux/slices/adminSlice";
import { SetTable } from "@/components/SetTable";
import { Card } from "@/components/ui/card";
import { Users, AlertTriangle, Building, HomeIcon, Loader2 } from "lucide-react";
import CredCard from "@/components/StatsCard/CredsCard";
import SimpleCard from "@/components/simple-card";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";

const Details: React.FC = () => {
	const { developerId } = useParams();
	const location = useLocation();
	const { admin } = location.state || {};
	const [activeTab, setActiveTab] = useState("adminUsers");
	const dispatch = useDispatch<AppDispatch>();
	const { adminData, remainingLicenses, totalFlats, licenses } = useSelector((state: RootState) => state.admin);
	const { buildings } = useSelector((state: RootState) => state.buildings);
	const [isActive, setIsActive] = useState(admin?.isActive);
	const [loading, setLoading] = useState(false);
	useEffect(() => {
		dispatch(getAdminData(developerId));
		dispatch(getRemainingLinceces({ adminId: developerId }))
		dispatch(fetchBuildings({ query: developerId })).catch(() => {
			toast.error("Failed to fetch buildings.");
		});
	}, [developerId]);

	const handleToggleActive = async () => {
		setLoading(true);
		await dispatch(toggleAdminStatus({
			developerId, isActive: !isActive, callBack: (data: any) => {
				if (data.success) {
					toast.success(data.message);
					setIsActive(!isActive);
				} else {
					toast.error(data.data.error);
				}
				setLoading(false);
			}
		}));
	};
	const adminUsertableKeys = [
		{
			username: "adminUsers.username",
		},
		{
			password: "adminUsers.plainTextPassword",
		},
	];
	const buildingtableKeys = [
		{
			name: "name",
		},
		{
			location: "location.address",
		},
		{
			owner: "owner.name",
		},
		{
			Status: "isActive",
		},
	];
	return (
		<>
			{/* <DashHeader title="Developer Details" /> */}
			<h1 className=" py-5 text-3xl font-bold tracking-tight">Developer Details</h1>
			<div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
				{
					adminData &&
					<>
						<SimpleCard title="Total Licencses" number={adminData?.licenses || 0} description="+2% from last month" Icon={HomeIcon} />
						<SimpleCard title="Buildings" number={buildings?.length || 0} description="-5% from last week" Icon={Building} />
						<SimpleCard title="Users" number={adminData?.adminUsers?.length || 0} description="+10% from last week" Icon={Users} />
						<SimpleCard title="Remaing License" number={remainingLicenses || 0} description="+12% from last hour" Icon={AlertTriangle} />
					</>
				}
			</div>
			<div className="container">
				<Card className="border border-gray-200 shadow-sm p-6">
					<div className="flex justify-between items-center mb-6">
						<h2 className="text-2xl font-semibold text-gray-900">Details</h2>
						<Button onClick={handleToggleActive} variant={isActive ? "destructive" : "default"} disabled={loading}>
							{loading && <Loader2 className="animate-spin mr-2" />}
							{isActive ? "Deactivate Developer" : "Activate Developer"}
						</Button>
					</div>
					<div className="grid gap-6 md:grid-cols-2">
						<div className="space-y-4">
							<div className="space-y-1">
								<p className="text-sm font-medium text-gray-500">Name</p>
								<p className="text-lg text-gray-900">{adminData?.name || "N/A"}</p>
							</div>
							<div className="space-y-1">
								<p className="text-sm font-medium text-gray-500">Phone</p>
								<p className="text-lg text-gray-900">{adminData?.contactInfo?.phone || "N/A"}</p>
							</div>
						</div>
						<div className="space-y-4">
							<div className="space-y-1">
								<p className="text-sm font-medium text-gray-500">Email</p>
								<p className="text-lg text-gray-900">{adminData?.contactInfo?.email || "N/A"}</p>
							</div>
							<div className="space-y-1">
								<p className="text-sm font-medium text-gray-500">Status</p>
								<p className={`text-lg font-medium ${isActive ? "text-green-600" : "text-red-600"}`}>
									{isActive ? "Active" : "Inactive"}
								</p>
							</div>
						</div>
					</div>
				</Card>
			</div>
			<div>
				<div className="mt-6">
					<div className="flex border-b border-gray-200">
						{["adminUsers", "Buildings"].map((tab) => (
							<button
								key={tab}
								onClick={() => setActiveTab(tab)}
								className={`py-2 px-6 font-medium text-sm ${activeTab === tab ? "border-b-2 border-blue-500 text-blue-500" : "text-gray-500"} transition`}
							>
								{tab === "adminUsers" ? "Admin Users" : "Buildings"}
							</button>
						))}
					</div>

					<div className="mt-6">
						<div className="my-6 flex flex-col gap-2 bg-light_gray rounded-lg p-4">
							{
								activeTab === "adminUsers" &&
								adminData?.adminUsers?.map((item: any, i: number) => (
									<React.Fragment key={i}>
										<CredCard key={i} username={item.username} plainTextPassword={item.plainTextPassword} />
									</React.Fragment>
								))
								// <SetTable data={adminData?.adminUsers} tableKeys={adminUsertableKeys} />
							}
							{activeTab === "Buildings" && (
								<SetTable data={buildings} tableKeys={buildingtableKeys} />
							)}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Details;
